export const iconFontAwesomeMoneyCommentsDollar = (
	<i className="fa-solid fa-comments-dollar"></i>
);
